module.exports = require("cuid");


//////////////////
// WEBPACK FOOTER
// external "cuid"
// module id = 33
// module chunks = 0 1